import styled from "styled-components";

export const Container = styled.div`
  z-index: 1;
  position: absolute;
`;
